"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUserDetails = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateUserDetails = (0, validation_1.properties)({
    id: (0, validation_1.text)(),
    email: (0, validation_1.text)(),
    familyName: (0, validation_1.text)(undefined, 0),
    givenName: (0, validation_1.text)(undefined, 0),
    trackingId: (0, validation_1.optional)((0, validation_1.text)(undefined, 0)),
    portalAuthToken: (0, validation_1.optional)((0, validation_1.text)(undefined, 0)),
});
//# sourceMappingURL=UserDetails.js.map